import { render, staticRenderFns } from "./appAdminCommands.vue?vue&type=template&id=1d4e336f&scoped=true"
import script from "./appAdminCommands.vue?vue&type=script&lang=js"
export * from "./appAdminCommands.vue?vue&type=script&lang=js"
import style0 from "./appAdminCommands.vue?vue&type=style&index=0&id=1d4e336f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4e336f",
  null
  
)

export default component.exports